<template>
  <FriedTableCell class="name-cell">
    <div class="name-cell-inner" @click.stop>
      <FriedParagraph
        v-tooltip="{
          distance: 5,
          placement: TooltipPlacement.Top,
          content: disabled ? $t('dr_add_resource_disabled') : `${tooltipPrefix}${truncatedName}`,
          disabled: !resource.title,
          triggers: ['hover', 'click', 'focus'],
        }"
        :class="['name-text truncate', { disabled }]"
        @click="$emit('click', resource)"
        >{{ resource.title || t('no-name') }}</FriedParagraph
      >
    </div>
  </FriedTableCell>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent, computed } from 'vue';
import { Placement as TooltipPlacement } from '@getaccept/fried-tofu';
import { useI18n } from 'vue-i18n';
import { LibraryHelper } from '@getaccept/lib-shared/src/library/helpers/library.helper';
import type { DsrResource } from '@getaccept/lib-shared/src/library/types/dsr-resource';

export default defineComponent({
  name: 'NameCell',
  props: {
    resource: {
      type: Object as PropType<DsrResource>,
      required: true,
    },
    tooltipPrefix: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
    },
  },
  emits: ['click'],
  setup(props) {
    const { t } = useI18n();
    const truncatedName = computed(() => LibraryHelper.getTruncatedText(props.resource.title, 120));

    return { truncatedName, TooltipPlacement, t };
  },
});
</script>

<style lang="scss" scoped>
@import '@getaccept/lib-shared/src/assets/scss/truncate-text';

.name-cell {
  width: 1px;

  .name-cell-inner {
    display: inline-flex;
    align-items: center;
    width: 100%;
    gap: var(--spacing-100);

    .name-text {
      width: fit-content;

      &:not(.disabled) {
        &:focus[data-focus-visible-added],
        &:hover {
          text-decoration: underline;
          cursor: pointer;
        }
      }

      &.disabled {
        color: var(--gray-60);
      }
    }
  }
}
</style>
